import React, { useState, useEffect } from 'react';
import { Box, Text, HStack } from '@chakra-ui/react';
import "./ClockBar.css";

const ClockBar: React.FC = () => {
  const [timeNY, setTimeNY] = useState('');
  const [timeITA, setTimeITA] = useState('');
  const [timeCN_SH, setTimeCN_SH] = useState('');
  const [timeSYD, setTimeSYD] = useState('');

  const getTime = (offset: number): string => {
    const localTime = new Date();
    const utc = localTime.getTime() + (localTime.getTimezoneOffset() * 60000);
    const time = new Date(utc + (3600000 * offset));
    return time.toLocaleTimeString();
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeNY(getTime(-5));
      setTimeITA(getTime(+1));
      setTimeCN_SH(getTime(+8));
      setTimeSYD(getTime(+11));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box className="clock-bar-container">
      <HStack spacing={4} align="center">
        <Text className="clock-text"><strong>NY:</strong> {timeNY}</Text>
        <Text className="clock-text"><strong>ITA:</strong> {timeITA}</Text>
        <Text className="clock-text"><strong>CN-SH:</strong> {timeCN_SH}</Text>
        <Text className="clock-text"><strong>SYD:</strong> {timeSYD}</Text>
      </HStack>
    </Box>
  );
};

export default ClockBar;